( function () {
	'use strict';

	function addEvidencesModalCtrl ( TITLE, TOOLTIP_MESSAGES ) {
		var self      = this;

		self.evidence = TITLE.evidence;
		self.tooltip  = TOOLTIP_MESSAGES;

		function toggle () {
			self.display = !self.display;
		}

		self.display       = false;
		self.toggleHandler = toggle;
	}

	angular
		.module( 'app.components' )
		.controller( 'addEvidencesModalCtrl', addEvidencesModalCtrl );

	addEvidencesModalCtrl.$inject = [ 'TITLE', 'TOOLTIP_MESSAGES' ];
} )( );
